import React from 'react';
import { Loader } from '@philips-internal/oswald-ui-components';
import './foundation-loader.css';
function FoundationLoader() {
    return (React.createElement(Loader, { className: "c-foundation__loader", size: 64 }));
}
export default FoundationLoader;
//# sourceMappingURL=foundation-loader.js.map